export default __webpack_public_path__ + "static/media/plus.51e45474.svg";